svg{vertical-align:middle}
/*# sourceMappingURL=project-shapes-button.component.css.map */
